import { render, staticRenderFns } from "./PhotoBookDesigner.vue?vue&type=template&id=0b551f9f&scoped=true"
import script from "./PhotoBookDesigner.vue?vue&type=script&lang=js"
export * from "./PhotoBookDesigner.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookDesigner.vue?vue&type=style&index=0&id=0b551f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b551f9f",
  null
  
)

export default component.exports